import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from "@angular/forms";

export function uniqueFormArrayValidator(formControl: AbstractControl): ValidationErrors | null {
    if (!(formControl instanceof FormArray)) return null;
    
    const values = formControl.controls.map(control => control.get('value')?.value?.trim().toLowerCase());
    const hasDuplicates = new Set(values).size !== values.length;
    return hasDuplicates ? { notUnique: true} : null
}

export function atLeastOneSelectedCheckbox(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const formArray = control as FormArray;

        for (let i = 0; i < formArray.length; i++) {
            if (formArray.at(i).value === true) {
                // no error found
                return null;
            }
        }
        // error found
        return { required: true };
    }
}